import { URL, WS_URL, API, IP_ADDR } from './endpoint';

const constants = {
  URL, WS_URL, API, IP_ADDR
};

export default constants;